import { IntlType } from 'components/ErrorToastValidation/types';
import { getNumberFromCurrency } from 'pages/VendorsTablePage/components/VendorsTable/helpers';
import { formattedDate } from 'utils/dateUtils';
import {
  AuthorizationPaymentListItem,
  AuthorizationPaymentRecordType
} from './types';

export const getFormattedList = (
  list: AuthorizationPaymentRecordType[]
): AuthorizationPaymentListItem[] =>
  list.map(item => ({
    vendorNo: item.vendorNo,
    vendorName: item.vendorName,
    invoiceId: item.invoiceId,
    amount: getNumberFromCurrency(item.amount),
    invoiceDescription: item.invoiceDescription,
    invoiceDate: formattedDate(item.invoiceDate as string),
    dueDate: formattedDate(item.dueDate as string),
    discountAmount: getNumberFromCurrency(item.discountAmount),
    netAmount: getNumberFromCurrency(item.netAmount),
    onHold: item.onHold
  }));

export const getFormattedIntlErrorList = (errorList: string[]): IntlType[] =>
  errorList.map((item, index) => ({
    id: `${index}`,
    description: `Error Message - ${index}`,
    defaultMessage: item
  }));
